<template>
    <div class="product-card">
        <div
            :id="productId"
            class="image-slider"
            @mouseenter="StartInterval()"
            @mouseleave="StopSlideShow()"
        >
            <div>
                <img
                    v-for="(image, index) in images"
                    :key="index"
                    :src="image"
                    :alt="productTitle"
                    :data-image-index="index"
                    :class="['product-img', index==PreviousIndex?'fadeout':
                    index==CurrentIndex ? 'fadein':'no-opacity',
                    ]"
                />
            </div>
        </div>
        <div class="image-dots" :id="productId+'-dot'"
          style="text-align:center">
            <span v-if="images.length>1" @click="SetPreviousImage()" class="image-slider-arrows">
                <i class="fas fa-angle-left"></i>
            </span>
            <span
                v-for="(image, index) in images"
                :key="productId+index+'dot'"
                @click="SetSlide(index)"
                :class="['dot', CurrentIndex==index ? 'active': '']"
            ></span>
            <span v-if="images.length>1" @click="SetNextImage()" class="image-slider-arrows">
                <i class="fas fa-angle-right"></i>
            </span>
        </div>
        <div class="product-card-content">
            <h4 class="product-card-heading">{{ productTitle }}</h4>
            <p class="product-card-paragraph">Size: {{ size }}</p>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ProductCard',
  data() {
    return {
      CurrentIndex: 0,
      PreviousIndex: -1,
      SliderTimeOut: null,
      IsTimerOn: false,
    };
  },
  props: {
    images: Array,
    productId: String,
    productTitle: String,
    productDecription: String,
    size: String,
  },
  methods: {
    SetPreviousImage() {
      this.$ga.event({
        eventCategory: 'Product card',
        eventAction: 'Previous clicked',
        eventLabel: this.productId,
      });
      const n = this.images.length;
      if ((this.CurrentIndex - 1) < 0) {
        this.PreviousIndex = this.CurrentIndex;
        this.CurrentIndex = n - 1;
      } else {
        this.PreviousIndex = this.CurrentIndex;
        this.CurrentIndex -= 1;
      }
    },
    SetNextImage() {
      this.$ga.event({
        eventCategory: 'Product card',
        eventAction: 'Next clicked',
        eventLabel: this.productId,
      });
      const n = this.images.length;
      if ((this.CurrentIndex + 1) >= n) {
        this.PreviousIndex = this.CurrentIndex;
        this.CurrentIndex = 0;
      } else {
        this.PreviousIndex = this.CurrentIndex;
        this.CurrentIndex += 1;
      }
    },
    SetSlide(index) {
      this.$ga.event({
        eventCategory: 'Product card',
        eventAction: 'Dot clicked',
        eventLabel: this.productId,
      });

      if (index !== this.CurrentIndex) {
        this.PreviousIndex = this.CurrentIndex;
        this.CurrentIndex = index;
      }
    },
    StartInterval() {
      this.$ga.event({
        eventCategory: 'Product card',
        eventAction: 'Slide Show Started',
        eventLabel: this.productId,
      });

      if (this.images.length > 1) {
        if (!this.IsTimerOn) {
          this.StartSlideShow();
          this.IsTimerOn = true;
          this.SliderTimeOut = setInterval(this.StartSlideShow, 3000);
        }
      }
    },
    StartSlideShow() {
      const n = this.images.length;
      if ((this.CurrentIndex + 1) >= n) {
        this.PreviousIndex = this.CurrentIndex;
        this.CurrentIndex = 0;
      } else {
        this.PreviousIndex = this.CurrentIndex;
        this.CurrentIndex += 1;
      }
    },
    StopSlideShow() {
      if (this.IsTimerOn) {
        this.$ga.event({
          eventCategory: 'Product card',
          eventAction: 'Slide Show Stopped',
          eventLabel: this.productId,
        });

        clearInterval(this.SliderTimeOut);
        this.IsTimerOn = false;
      }
    },
  },
};
</script>
